import React from "react";
import { AlertCircle } from "lucide-react";

export class SectionErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }

  static getDerivedStateFromError(err) {
    return { err };
  }

  componentDidCatch(err, info) {
    // Log so it's visible in the browser console & any external error tracker
    // eslint-disable-next-line no-console
    console.error(`[${this.props.label || "Section"}] render error:`, err, info?.componentStack);
  }

  reset = () => this.setState({ err: null });

  render() {
    if (this.state.err) {
      const msg = this.state.err?.message || String(this.state.err);
      return (
        <div className="border-2 border-red-200 bg-red-50 rounded-xl p-6 text-left" data-testid="section-error-boundary">
          <div className="flex items-start gap-3">
            <AlertCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <p className="font-bold text-red-800 text-base">Couldn't load this section</p>
              <p className="text-sm text-red-700 mt-1">{this.props.label || "Section"} hit an error while rendering.</p>
              <pre className="mt-2 text-[11px] bg-white border border-red-200 rounded p-2 overflow-x-auto text-red-900 whitespace-pre-wrap break-words">{msg}</pre>
              <button
                type="button"
                onClick={this.reset}
                className="mt-3 px-3 py-1.5 rounded-md bg-red-600 hover:bg-red-700 text-white text-xs font-medium"
                data-testid="section-error-reset"
              >
                Try again
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
